import React, { useState } from "react";
import discount from "../../../../assets/img/admin/discount-shape.svg";
import building from "../../../../assets/img/admin/buildings-1.svg";
import house from "../../../../assets/img/admin/house-4.svg";
import WageForAllRes from "./WageModal.js/WageForAllRes";
import WageForCodeRes from "./WageModal.js/WageForCodeRes";
import WageForTypeRes from "./WageModal.js/WageForTypeRes";
import PersianNumber from "../../../shared/PersianNumber";
const WebsiteWageCard = ({ img, title, button, id,openModal }) => {

  return (
    <div className={`WebsiteWageCard WebsiteWageCard-${id}`}>
      <img src={img} />
      <h5 className="text-[#fff] text-center  text-[24px] font-[900]">
        {title}
      </h5>
      <button onClick={openModal} className="text-[#fff] border-b border-b-[#fff] text-[18px]">
        {button}
      </button>
    </div>
  );
};
const WebsiteWage = ({apiWageList,WageList,setGeneralWage,setCodeWage,setTypeWage}) => {


  return (
    <div>
      <h4 className="text-[36px] text-[#12171C] font-[700] mb-[36px] ">
        کارمزد های وبسایت
      </h4>
      <div className="WebsiteWage">
        <WebsiteWageCard
          id={3}
          title={<PersianNumber number={`${WageList.general?.wage_percentage ?WageList.general?.wage_percentage : 0 }%`}  />}
          button="تعیین کنید"
          img={discount}
          openModal={()=>setGeneralWage(true)}

        />

        <WebsiteWageCard
          id={2}
          title="کـارمزد بـرای
        هر اقامتگاه"
          button="تعیین کنید"
          img={building}
          openModal={()=>setCodeWage(true)}

        />
        <WebsiteWageCard
          id={1}
          title="کـارمـــزد بــــرای
انواع اقامتگاه"
          button="تعیین کنید"
          img={house}
          openModal={()=>setTypeWage(true)}

         
        />
      </div>
     
    </div>
  );
};

export default WebsiteWage;
